import { useState, useEffect } from 'react';
import {
  SUDO_API_ENDPOINT,
  TANSTACK_ONCHAIN_POINTS_KEY,
} from '../utils/constants';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export interface TraderOnChainPoints {
  objectId: string;
  distinctUserId: string;
  amount: number;
  digest: string;
  claimTx: string;
  startTimeMs: string;
  endTimeMs: string;
  createdAt: Date;
  formattedTimeRange?: string;
  claimable?: boolean;
}

const useTraderOnChainPoints = (address: string) => {
  return useQuery({
    queryKey: [TANSTACK_ONCHAIN_POINTS_KEY, address],
    queryFn: async () => {
      if (!address) return [];

      const fetchTraderPoints = async () => {
        if (!address.startsWith('0x')) {
          return [];
        }
        try {
          const response = await fetch(
            `${SUDO_API_ENDPOINT}/onChainPoints?address=${address}`,
          );
          const data = await response.json();
          return data;
        } catch (error) {
          console.error('Error fetching trader on chain points:', error);
        }
      };

      const points: TraderOnChainPoints[] = await fetchTraderPoints();
      return points;
    },
  });
};

export default useTraderOnChainPoints;
